var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useForward } from '../../common/hooks';
import { InputRoot } from './components/input-root';
import { useTextInput } from './text-input.hook';
export var TextInput2 = React.forwardRef(function (_a, ref) {
    var inputStyle = _a.inputStyle, numeric = _a.numeric, props = __rest(_a, ["inputStyle", "numeric"]);
    if (numeric)
        props.type = 'number';
    var forwardRef = useForward(ref);
    var _b = useTextInput(props, forwardRef), container = _b.container, input = _b.input;
    return _jsx(_Fragment, { children: _jsx(InputRoot, __assign({}, props, container, { children: _jsx("input", __assign({}, input, { style: __assign({}, inputStyle), ref: forwardRef })) })) });
});
